export const OPEN_FILTERS = "OPEN_FILTERS";

export const CLOSE_FILTERS = "CLOSE_FILTERS";

export const SET_FILTERS = "SET_FILTERS";

export const CLEAR_FILTERS = "CLEAR_FILTERS";
